export default {
  name: 'ZoneSelectionStore',
  state: {
    vmd: false,
    svg: null,
    pt: null,
    polyGroup: null,
    polyMask: null,
    polyZoneShadow: null,
    enabled: false,
    rectCoords: {
      upperLeftX: null,
      upperLeftY: null,
      boxWidth: null,
      boxHeight: null
    },
    pathCoords: [],
    detectionSize: {
      upperLeftX: 0,
      upperLeftY: 0,
      boxWidth: 3,
      boxHeight: 3
    },
    showDetectionSize: false,
    enableRectSelector: false,
    enableResizeGroup: false,
    polyPoints: '',
    renderSquares: false,
    alarmOn: false,
    alarmPath: null
  }
};
